// Font Awesome Free (solid lock), CC BY 4.0 — https://fontawesome.com/license/free.
// Le cadenas des fonctionnalités payantes : entrées verrouillées du menu coach
// et écrans « fonctionnalité réservée » (Classement coach et élève).
// Le tracé monte jusqu'à y = -32 (haut de l'anse) : la viewBox part de -32,
// sinon le haut du cadenas est rogné.
const FaLockIcon = ({ className, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -32 384 544"
    className={className}
    style={style}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M128 96l0 64 128 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64zM64 160l0-64C64 25.3 121.3-32 192-32S320 25.3 320 96l0 64c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64z" />
  </svg>
);

export default FaLockIcon;
